import axios from 'axios'
import baseService from './baseService'
import customerData from './data/customer'

const customerService = {
  all (searchCriteriaModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(customerData)
      } else {
        axios
          .post('/leadmcd/list', searchCriteriaModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  single (customerId) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(customerData.all.find((x) => x.id === customerId))
      } else {
        axios
          .get('/leadmcd/get?id=' + customerId, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getDealer (dealerCode) {
    return new Promise((resolve, reject) => {
      axios
        .get('/leadmcd/' + dealerCode + '/lcr/', baseService.defaultConfig)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response.data)
        })
    })
  },
  getBusinessDealer (dealerCode) {
    return new Promise((resolve, reject) => {
      axios
        .get('/leadmcd/' + dealerCode + '/blcr/', baseService.defaultConfig)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response.data)
        })
    })
  },
  findAllByDealerId (dealerCode) {
    return new Promise((resolve, reject) => {
      axios
        .get('/leadmcd/findAllByDealerId?dealerCode=' + dealerCode, baseService.defaultConfig)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response.data)
        })
    })
  },
  save (customerModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        var customer = customerData.all.find((x) => x.id === 1)
        customerData.all.push(customer)
        resolve(customer)
      } else {
        axios
          .post('/leadmcd/saveleadcreditapplication', customerModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  saveBusiness (customerModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        var customer = customerData.all.find((x) => x.id === 1)
        customerData.all.push(customer)
        resolve(customer)
      } else {
        axios
          .post('/leadmcd/savebusinessleadcreditapplication', customerModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  fetchMakes (dealerId) {
    return new Promise((resolve, reject) => {
      axios
        .get('/leadmcd/dealerMakes', { params: { dealerId: dealerId } }, baseService.defaultConfig)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response.data)
        })
    })
  },
  getCreditApplication (token) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(customerData.all.find((x) => x.id === 1))
      } else {
        axios
          .get('/leadmcd/getcreditapplication', { params: { token: token } }, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getBusinessCreditApplication (token) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(customerData.all.find((x) => x.id === 1))
      } else {
        axios
          .get('/leadmcd/getbusinesscreditapplication', { params: { token: token } }, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  update (customerModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve('')
      } else {
        axios
          .post('/leadmcd/updatecreditapplication', customerModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  updateBusiness (customerModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve('')
      } else {
        axios
          .post('/leadmcd/updatebusinesscreditapplication', customerModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getCustomerIdentityVerification (token) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(customerData.all.find((x) => x.id === 1))
      } else {
        axios
          .get('/leadmcd/getidentityverification', { params: { token: token } }, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  updateIdentityVerification (customerModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        var customer = customerData.all.find((x) => x.id === 1)
        customerData.all.push(customer)
        resolve(customer)
      } else {
        axios
          .post('/leadmcd/updateidentityverification', customerModel, baseService.defaultConfig, {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  allStates () {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve([])
      } else {
        axios
          .get('/customer/allStates', baseService.defaultConfig, {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              'Access-Control-Allow-Origin': '*'
            }
          }).then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      }
    })
  },
  updateDocumentVerification (customerModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        var customer = customerData.all.find((x) => x.id === 1)
        customerData.all.push(customer)
        resolve(customer)
      } else {
        axios
          .post('/leadmcd/updatedocumentverification', customerModel, baseService.defaultConfig, {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getCustomerDocumentVerification (token) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(customerData.all.find((x) => x.id === 1))
      } else {
        axios
          .get('/leadmcd/customerdocumentverification', { params: { token: token } }, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  findByContactInfo (leadSearchModel) {
    return new Promise((resolve, reject) => {
      axios
        .post('/leadmcd/findbycontactinfo', leadSearchModel, baseService.defaultConfig)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response.data)
        })
    })
  }
}

export default customerService
